import axios from 'axios';
import { getAPIHost } from '../../utils';

const shareFile = (formData) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${getAPIHost()}/share-a-file`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to share file'));
            });
    });

export default shareFile;
